import { useState, useEffect } from 'react'

const useLocalStorage = (key, defaultValue) => {
  const getStorageValue = (key, defaultValue) => {
    // getting stored value
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem(key)
      const initial = saved !== null ? JSON.parse(saved) : defaultValue
      return initial
    }
  }

  const [value, setValue] = useState(() => {
    return getStorageValue(key, defaultValue)
  })

  useEffect(() => {
    // storing input name
    localStorage.setItem(key, JSON.stringify(value))
  }, [key, value])

  return [value, setValue]
}

export default useLocalStorage
